"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
/* eslint-disable import/extensions */
/* eslint-disable camelcase */
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var api_1 = require("@src/api");
var BotActions_1 = require("@src/actions/BotActions");
var dispatcher_1 = require("@src/dispatcher");
var CommonStore_1 = __importDefault(require("@src/stores/CommonStore"));
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var DomainActions_1 = require("@src/actions/DomainActions");
var const_1 = require("@src/containers/CodeNode/utils/const");
var box_1 = __importDefault(require("relements/build/esm/ui/box"));
var accordion_1 = __importDefault(require("relements/build/esm/ui/accordion"));
var dropdown_1 = __importDefault(require("relements/build/esm/input/dropdown"));
var loader_1 = __importDefault(require("relements/build/esm/ui/loader"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var toggle_1 = __importDefault(require("relements/build/esm/input/toggle"));
// Store
var store_1 = __importDefault(require("@src/store"));
// Components
// eslint-disable-next-line import/extensions
var StyledComponets_1 = require("./StyledComponets");
// eslint-disable-next-line import/extensions
var Label_1 = __importDefault(require("./Label"));
var VoiceAgentToolItem_1 = __importDefault(require("./VoiceAgentToolItem"));
var VoiceAgentSidebar_1 = __importDefault(require("./VoiceAgentSidebar"));
var VoiceAgentAddAgentModal_1 = __importDefault(require("./VoiceAgentAddAgentModal"));
var VoiceAgentDynamicSettings_1 = __importDefault(require("./VoiceAgentDynamicSettings"));
var WorkflowAgentBuilder_1 = __importDefault(require("./WorkflowAgentBuilder"));
var VoiceAgentLayoutUtils_1 = require("./VoiceAgentLayoutUtils");
var api_2 = require("../store/api");
var selectors_1 = require("../store/selectors");
var actions_1 = require("../store/actions");
var normalizeDynamicSettingsTemplate = function (template) {
    if (Array.isArray(template))
        return template;
    if (Array.isArray(template === null || template === void 0 ? void 0 : template.agent_settings_template)) {
        return template.agent_settings_template;
    }
    if (Array.isArray(template === null || template === void 0 ? void 0 : template.dynamic_settings)) {
        return template.dynamic_settings;
    }
    if (Array.isArray(template === null || template === void 0 ? void 0 : template.settings)) {
        return template.settings;
    }
    return [];
};
var VoiceAgentLayout = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
    var onAddAgentClick = _a.onAddAgentClick, onDeleteClick = _a.onDeleteClick, onParentSave = _a.onSave, isEdited = _a.isEdited, onDirtyStateChange = _a.onDirtyStateChange, workflowAudioRegenerationInProgress = _a.workflowAudioRegenerationInProgress, workflowAudioRegenerationFailed = _a.workflowAudioRegenerationFailed;
    var reduxDispatch = react_redux_1.useDispatch();
    var languages = CommonStore_1["default"].getMetaTags().allLanguages;
    var activeDomainId = (_c = (_b = CommonStore_1["default"].getMetaTags()) === null || _b === void 0 ? void 0 : _b.domain) === null || _c === void 0 ? void 0 : _c.id;
    var botSettings = react_redux_1.useSelector(selectors_1.getDomainData);
    var botSettingsDomainId = (_d = botSettings === null || botSettings === void 0 ? void 0 : botSettings.id) !== null && _d !== void 0 ? _d : botSettings === null || botSettings === void 0 ? void 0 : botSettings.domain_id;
    var isDomainDataSynced = String(botSettingsDomainId !== null && botSettingsDomainId !== void 0 ? botSettingsDomainId : '') === String(activeDomainId !== null && activeDomainId !== void 0 ? activeDomainId : '');
    var pipecatVoiceId = isDomainDataSynced
        ? Number(botSettings === null || botSettings === void 0 ? void 0 : botSettings['pipecat_voice_id'])
        : Number.NaN;
    // Workflow APIs receive Bot Builder's normal domain id. Haptik resolves its
    // internal Pipecat/voice-bot id server-side, keeping runtime identifiers out
    // of the browser.
    var workflowDomainId = activeDomainId || null;
    var languagesList = languages.filter(function (lang) { var _a; return (_a = botSettings === null || botSettings === void 0 ? void 0 : botSettings['supported_languages']) === null || _a === void 0 ? void 0 : _a.includes(lang.code); });
    var _x = react_1["default"].useState([]), agents = _x[0], setAgents = _x[1];
    var _y = react_1["default"].useState([]), workflowAgents = _y[0], setWorkflowAgents = _y[1];
    var _z = react_1["default"].useState(true), isWorkflowAgentsLoading = _z[0], setIsWorkflowAgentsLoading = _z[1];
    var _0 = react_1["default"].useState(null), selectedWorkflowAgentId = _0[0], setSelectedWorkflowAgentId = _0[1];
    var _1 = react_1["default"].useState(null), workflowBuilderAgent = _1[0], setWorkflowBuilderAgent = _1[1];
    var _2 = react_1["default"].useState([]), agentSettingsTemplate = _2[0], setAgentSettingsTemplate = _2[1];
    var _3 = react_1["default"].useState(null), selectedSelection = _3[0], setSelectedSelection = _3[1];
    var _4 = react_1["default"].useState(languagesList[0]), selectedLanguage = _4[0], setSelectedLanguage = _4[1];
    var initializedLanguageKeyRef = react_1["default"].useRef('');
    var _5 = react_1["default"].useState(null), currentAgentDraft = _5[0], setCurrentAgentDraft = _5[1];
    var _6 = react_1["default"].useState(VoiceAgentLayoutUtils_1.normalizeCommonConfigurationDraft(botSettings)), currentCommonDraft = _6[0], setCurrentCommonDraft = _6[1];
    var _7 = react_1["default"].useState((_f = (_e = VoiceAgentLayoutUtils_1.normalizeCommonConfigurationDraft(botSettings)) === null || _e === void 0 ? void 0 : _e.tools) !== null && _f !== void 0 ? _f : []), commonTools = _7[0], setCommonTools = _7[1];
    var _8 = react_1["default"].useState(false), isLocalEdited = _8[0], setIsLocalEdited = _8[1];
    var _9 = react_1["default"].useState(false), isCommonEdited = _9[0], setIsCommonEdited = _9[1];
    var _10 = react_1["default"].useState([]), voiceModels = _10[0], setVoiceModels = _10[1];
    var _11 = react_1["default"].useState(true), isLoading = _11[0], setIsLoading = _11[1];
    var _12 = react_1["default"].useState(true), isModelsLoading = _12[0], setIsModelsLoading = _12[1];
    var _13 = react_1["default"].useState(false), isSaving = _13[0], setIsSaving = _13[1];
    var _14 = react_1["default"].useState(false), isDeleteLoading = _14[0], setIsDeleteLoading = _14[1];
    var _15 = react_1["default"].useState(false), isAddAgentModalActive = _15[0], setIsAddAgentModalActive = _15[1];
    var _16 = react_1["default"].useState(false), dynamicSettingsAccordionActive = _16[0], setDynamicSettingsAccordionActive = _16[1];
    var _17 = react_1["default"].useState(''), newAgentName = _17[0], setNewAgentName = _17[1];
    var _18 = react_1["default"].useState(''), newAgentNameError = _18[0], setNewAgentNameError = _18[1];
    var _19 = react_1["default"].useState(null), activeCodeEditor = _19[0], setActiveCodeEditor = _19[1];
    var lastSelectedSelectionRef = react_1["default"].useRef(null);
    var lastAccordionResetAgentIdRef = react_1["default"].useRef(null);
    var ensureToolCallLambdaNames = react_1["default"].useCallback(function (draft) { return __awaiter(void 0, void 0, void 0, function () {
        var tools, pendingLambdaTools, updatedTools, lambdaResults;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    tools = Array.isArray(draft === null || draft === void 0 ? void 0 : draft.tools) ? draft.tools : [];
                    pendingLambdaTools = tools
                        .map(function (tool, index) { return ({ tool: tool, index: index }); })
                        .filter(function (_a) {
                        var tool = _a.tool;
                        return ((tool === null || tool === void 0 ? void 0 : tool.mode) || '').toString().trim() === 'tool_call' &&
                            VoiceAgentLayoutUtils_1.getToolCallCodeType(tool) !== 'quick' &&
                            !((tool === null || tool === void 0 ? void 0 : tool.lambdaFunctionName) || '').toString().trim();
                    });
                    if (!pendingLambdaTools.length) {
                        return [2 /*return*/, draft];
                    }
                    updatedTools = __spreadArrays(tools);
                    return [4 /*yield*/, Promise.all(pendingLambdaTools.map(function (_a) {
                            var tool = _a.tool, index = _a.index;
                            return __awaiter(void 0, void 0, void 0, function () {
                                var payload, response, responseBody, lambdaFunctionName;
                                var _b, _c, _d;
                                return __generator(this, function (_e) {
                                    switch (_e.label) {
                                        case 0:
                                            payload = {};
                                            // The API expects snake_case payload keys here.
                                            // eslint-disable-next-line camelcase, dot-notation
                                            payload['custom_code_block'] =
                                                (tool === null || tool === void 0 ? void 0 : tool.code) || (tool === null || tool === void 0 ? void 0 : tool['custom_code_block']) ||
                                                    const_1.INIT_CODE_MULTI_VOICE_AGENT;
                                            if (((tool === null || tool === void 0 ? void 0 : tool.lambdaFunctionName) || '').toString().trim()) {
                                                // eslint-disable-next-line camelcase, dot-notation
                                                payload['function_name'] = tool.lambdaFunctionName;
                                            }
                                            return [4 /*yield*/, api_2.createCodeExecutorFunction(payload)];
                                        case 1:
                                            response = _e.sent();
                                            if (!(response === null || response === void 0 ? void 0 : response.success)) {
                                                throw new Error(((_b = response === null || response === void 0 ? void 0 : response.response) === null || _b === void 0 ? void 0 : _b.error) ||
                                                    "Failed to generate lambda name for Tool " + (index + 1) + ".");
                                            }
                                            responseBody = VoiceAgentLayoutUtils_1.getResponseBody(response === null || response === void 0 ? void 0 : response.response);
                                            lambdaFunctionName = (_d = (_c = responseBody === null || responseBody === void 0 ? void 0 : responseBody['lambda_function_name']) !== null && _c !== void 0 ? _c : responseBody === null || responseBody === void 0 ? void 0 : responseBody['function_name']) !== null && _d !== void 0 ? _d : '';
                                            if (!lambdaFunctionName) {
                                                throw new Error("Lambda name was not returned for Tool " + (index + 1) + ".");
                                            }
                                            return [2 /*return*/, { index: index, lambdaFunctionName: lambdaFunctionName }];
                                    }
                                });
                            });
                        }))];
                case 1:
                    lambdaResults = _a.sent();
                    lambdaResults.forEach(function (_a) {
                        var index = _a.index, lambdaFunctionName = _a.lambdaFunctionName;
                        updatedTools[index] = __assign(__assign({}, (updatedTools[index] || {})), { lambdaFunctionName: lambdaFunctionName });
                    });
                    return [2 /*return*/, __assign(__assign({}, (draft || {})), { tools: updatedTools })];
            }
        });
    }); }, []);
    var stripQuickToolLambdaNames = react_1["default"].useCallback(function (draft) {
        var tools = Array.isArray(draft === null || draft === void 0 ? void 0 : draft.tools) ? draft.tools : [];
        var updatedTools = tools.map(function (tool) {
            return ((tool === null || tool === void 0 ? void 0 : tool.mode) || '').toString().trim() === 'tool_call' &&
                VoiceAgentLayoutUtils_1.getToolCallCodeType(tool) === 'quick'
                ? __assign(__assign({}, tool), { lambdaFunctionName: '' }) : tool;
        });
        return __assign(__assign({}, (draft || {})), { tools: updatedTools });
    }, []);
    var selectedAgentId = selectedSelection === VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION
        ? null
        : selectedSelection;
    var selectedAgent = react_1["default"].useMemo(function () {
        if (!agents.length)
            return null;
        return (agents.find(function (agent) { return VoiceAgentLayoutUtils_1.getAgentId(agent) === selectedAgentId; }) || agents[0]);
    }, [agents, selectedAgentId]);
    var selectedLanguageCode = (selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.code) || (selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.id);
    var getDefaultLanguage = function () {
        var languageSpecificInstructions = (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.languageSpecificInstructions) || {};
        var languageWithValue = languagesList.find(function (lang) {
            var languageCode = (lang === null || lang === void 0 ? void 0 : lang.code) || (lang === null || lang === void 0 ? void 0 : lang.id);
            return (languageCode &&
                ((languageSpecificInstructions === null || languageSpecificInstructions === void 0 ? void 0 : languageSpecificInstructions[languageCode]) || '').toString().trim()
                    .length > 0);
        });
        return languageWithValue || languagesList[0] || null;
    };
    var configuredLanguageCount = Object.values((currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.languageSpecificInstructions) || {}).filter(function (value) { return (value || '').toString().trim().length > 0; }).length;
    var isAgentDefault = function (agent) { var _a, _b; return Boolean((_b = (_a = agent === null || agent === void 0 ? void 0 : agent['is_default']) !== null && _a !== void 0 ? _a : agent === null || agent === void 0 ? void 0 : agent.isDefault) !== null && _b !== void 0 ? _b : false); };
    var allAgents = __spreadArrays(agents, workflowAgents);
    var defaultAgentOtherThanCurrent = allAgents.find(function (agent) { return isAgentDefault(agent) && VoiceAgentLayoutUtils_1.getAgentId(agent) !== selectedAgentId; });
    var noDefaultAgent = !allAgents.some(function (agent) { return isAgentDefault(agent); });
    var orchestratorAgentOtherThanCurrent = agents.find(function (agent) {
        return ((agent === null || agent === void 0 ? void 0 : agent.role) === 'orchestrator' || (agent === null || agent === void 0 ? void 0 : agent['role']) === 'orchestrator') &&
            VoiceAgentLayoutUtils_1.getAgentId(agent) !== selectedAgentId;
    });
    var isFaq = (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.role) === 'faq';
    var selectedAgentSettingsTemplate = normalizeDynamicSettingsTemplate((_h = (_g = selectedAgent === null || selectedAgent === void 0 ? void 0 : selectedAgent.agent_settings_template) !== null && _g !== void 0 ? _g : selectedAgent === null || selectedAgent === void 0 ? void 0 : selectedAgent.agentSettingsTemplate) !== null && _h !== void 0 ? _h : agentSettingsTemplate);
    var commonConfigurationSource = react_1["default"].useMemo(function () { return (__assign(__assign({}, (botSettings || {})), { common_tools: commonTools })); }, [botSettings, commonTools]);
    var currentCommonConfiguration = react_1["default"].useMemo(function () { return VoiceAgentLayoutUtils_1.normalizeCommonConfigurationDraft(commonConfigurationSource); }, [commonConfigurationSource]);
    var sharedCommonTools = commonTools;
    var allAgentTools = react_1["default"].useMemo(function () {
        return agents.flatMap(function (agent) {
            return Array.isArray(agent === null || agent === void 0 ? void 0 : agent.tools) ? agent.tools : [];
        });
    }, [agents]);
    var selectedAgentDisplayName = ((currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.name) || (selectedAgent === null || selectedAgent === void 0 ? void 0 : selectedAgent.name) ||
        '')
        .toString()
        .trim();
    var normalizedSelectedAgentDisplayName = selectedAgentDisplayName
        .toLowerCase()
        .trim();
    var normalizedSelectedAgentId = String(selectedAgentId !== null && selectedAgentId !== void 0 ? selectedAgentId : '').trim();
    var isCommonToolSelfHandoff = function (tool) {
        if (((tool === null || tool === void 0 ? void 0 : tool.mode) || '').toString().trim() !== 'handoff')
            return false;
        var nextAgentValue = ((tool === null || tool === void 0 ? void 0 : tool.nextAgent) || '').toString().trim();
        if (!nextAgentValue)
            return false;
        var normalizedNextAgent = nextAgentValue.toLowerCase();
        return (normalizedNextAgent === normalizedSelectedAgentDisplayName ||
            nextAgentValue === normalizedSelectedAgentId);
    };
    var providerOptions = (function () {
        var providers = new Set();
        voiceModels.forEach(function (model) {
            var _a;
            var provider = (_a = model === null || model === void 0 ? void 0 : model['meta_data']) === null || _a === void 0 ? void 0 : _a.provider;
            if (provider)
                providers.add(provider);
        });
        return Array.from(providers).map(function (provider) { return ({
            id: provider,
            name: provider,
        }); });
    })();
    var modelOptions = (function () {
        return voiceModels
            .filter(function (model) {
            var _a;
            if (!(currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.modelProvider))
                return true;
            var provider = (_a = model === null || model === void 0 ? void 0 : model['meta_data']) === null || _a === void 0 ? void 0 : _a.provider;
            return provider === currentAgentDraft.modelProvider;
        })
            .map(function (model) {
            var _a, _b;
            return ({
                // id: model?.id ?? model?.name,
                id: (_a = model === null || model === void 0 ? void 0 : model.name) !== null && _a !== void 0 ? _a : model === null || model === void 0 ? void 0 : model.id,
                name: (_b = model === null || model === void 0 ? void 0 : model.name) !== null && _b !== void 0 ? _b : model === null || model === void 0 ? void 0 : model.id,
            });
        })
            .filter(function (model) { return model.id; });
    })();
    var agentOptions = react_1["default"].useMemo(function () {
        return agents
            .filter(function (agent) {
            if ((agent === null || agent === void 0 ? void 0 : agent.role) === 'workflow')
                return false;
            var id = String(VoiceAgentLayoutUtils_1.getAgentId(agent));
            return !workflowAgents.some(function (workflowAgent) { return String(VoiceAgentLayoutUtils_1.getAgentId(workflowAgent)) === id; });
        })
            .map(function (agent, index) { return ({
            id: VoiceAgentLayoutUtils_1.getAgentId(agent),
            name: VoiceAgentLayoutUtils_1.getAgentName(agent, index),
        }); });
    }, [agents, workflowAgents]);
    // Handoff targets are not the same list as the sidebar's. agentOptions above
    // deliberately drops workflow agents because the sidebar renders them in its
    // own section, but an agent must still be able to hand off to one: the
    // runtime starts that workflow at its entry node on the transition.
    var handoffAgentOptions = react_1["default"].useMemo(function () { return __spreadArrays(agentOptions, workflowAgents.map(function (agent, index) { return ({
        id: VoiceAgentLayoutUtils_1.getAgentId(agent),
        // Offset the fallback numbering so an unnamed workflow agent cannot
        // collide with an unnamed normal agent; handoff is resolved by name.
        name: VoiceAgentLayoutUtils_1.getAgentName(agent, agentOptions.length + index),
    }); })); }, [agentOptions, workflowAgents]);
    var fetchVoiceModels = react_1["default"].useCallback(function () {
        setIsModelsLoading(true);
        api_2.getVoiceModels()
            .then(function (_a) {
            var success = _a.success, response = _a.response;
            if (!success)
                return;
            var body = VoiceAgentLayoutUtils_1.getResponseBody(response);
            setVoiceModels(VoiceAgentLayoutUtils_1.normalizeList(body));
        })["catch"](function (error) {
            api_1.captureException(error);
        })["finally"](function () {
            setIsModelsLoading(false);
        });
    }, []);
    var fetchMultiAgents = react_1["default"].useCallback(function (preferredAgentId, showLoader) {
        if (preferredAgentId === void 0) { preferredAgentId = null; }
        if (showLoader === void 0) { showLoader = true; }
        if (!Number.isFinite(pipecatVoiceId))
            return;
        if (showLoader) {
            setIsLoading(true);
        }
        api_2.getMultiAgent(pipecatVoiceId)
            .then(function (_a) {
            var _b, _c, _d, _e, _f, _g, _h, _j;
            var success = _a.success, response = _a.response;
            if (!success) {
                BotActions_1.createAlert((response === null || response === void 0 ? void 0 : response.error) || 'Failed to fetch voice agents.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                setAgents([]);
                setCurrentAgentDraft(null);
                setSelectedSelection(null);
                setCommonTools([]);
                return;
            }
            var body = VoiceAgentLayoutUtils_1.getResponseBody(response);
            var fetchedAgents = VoiceAgentLayoutUtils_1.normalizeList((_c = (_b = body === null || body === void 0 ? void 0 : body.agents) !== null && _b !== void 0 ? _b : body === null || body === void 0 ? void 0 : body.data) !== null && _c !== void 0 ? _c : []).filter(function (agent) { return (agent === null || agent === void 0 ? void 0 : agent.role) !== 'workflow'; });
            var fetchedTemplate = normalizeDynamicSettingsTemplate((_f = (_e = (_d = body === null || body === void 0 ? void 0 : body.agent_settings_template) !== null && _d !== void 0 ? _d : body === null || body === void 0 ? void 0 : body.agentSettingsTemplate) !== null && _e !== void 0 ? _e : body === null || body === void 0 ? void 0 : body.dynamic_settings) !== null && _f !== void 0 ? _f : body === null || body === void 0 ? void 0 : body.settings);
            setAgents(fetchedAgents !== null && fetchedAgents !== void 0 ? fetchedAgents : []);
            setAgentSettingsTemplate(fetchedTemplate !== null && fetchedTemplate !== void 0 ? fetchedTemplate : []);
            setCommonTools((_j = (_h = VoiceAgentLayoutUtils_1.normalizeCommonConfigurationDraft({
                common_tools: (_g = body === null || body === void 0 ? void 0 : body.common_tools) !== null && _g !== void 0 ? _g : [],
            })) === null || _h === void 0 ? void 0 : _h.tools) !== null && _j !== void 0 ? _j : []);
            if (!fetchedAgents.length) {
                setSelectedSelection(preferredAgentId === VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION
                    ? VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION
                    : null);
                setCurrentAgentDraft(null);
                return;
            }
            // Without a requested agent, leave the choice to the effect that
            // picks the default across ordinary and workflow agents.
            setSelectedSelection(preferredAgentId);
            if (preferredAgentId !== null)
                setSelectedWorkflowAgentId(null);
        })["catch"](function (error) {
            BotActions_1.createAlert('Error occurred while fetching voice agents.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
            api_1.captureException(error);
        })["finally"](function () {
            if (showLoader) {
                setIsLoading(false);
            }
        });
    }, [pipecatVoiceId]);
    var fetchWorkflowAgents = react_1["default"].useCallback(function () {
        if (!workflowDomainId) {
            setWorkflowAgents([]);
            setIsWorkflowAgentsLoading(false);
            return undefined;
        }
        return api_2.getWorkflowAgents(workflowDomainId)
            .then(function (_a) {
            var _b, _c;
            var success = _a.success, response = _a.response;
            if (!success) {
                setWorkflowAgents([]);
                return;
            }
            var body = VoiceAgentLayoutUtils_1.getResponseBody(response);
            setWorkflowAgents(VoiceAgentLayoutUtils_1.normalizeList((_c = (_b = body === null || body === void 0 ? void 0 : body.agents) !== null && _b !== void 0 ? _b : body === null || body === void 0 ? void 0 : body.data) !== null && _c !== void 0 ? _c : []).filter(function (agent) { return (agent === null || agent === void 0 ? void 0 : agent.role) === 'workflow'; }));
        })["catch"](function (error) {
            setWorkflowAgents([]);
            api_1.captureException(error);
        })["finally"](function () { return setIsWorkflowAgentsLoading(false); });
    }, [workflowDomainId]);
    // Ordinary and workflow agents load separately. Once both have loaded and
    // nothing is selected, open the default agent, whichever list it is in, or
    // else the first agent in sidebar order (creation order, i.e. by id).
    react_1["default"].useEffect(function () {
        if (selectedSelection !== null || selectedWorkflowAgentId !== null)
            return;
        if (isLoading || isWorkflowAgentsLoading)
            return;
        // An agent still being created has no numeric id yet; it sorts last.
        var orderKey = function (agent) {
            var numeric = Number(VoiceAgentLayoutUtils_1.getAgentId(agent));
            return Number.isFinite(numeric) ? numeric : Number.MAX_SAFE_INTEGER;
        };
        var candidates = __spreadArrays(agents.map(function (agent) { return ({ agent: agent, isWorkflow: false }); }), workflowAgents.map(function (agent) { return ({ agent: agent, isWorkflow: true }); })).sort(function (first, second) { return orderKey(first.agent) - orderKey(second.agent); });
        var chosen = candidates.find(function (_a) {
            var agent = _a.agent;
            return isAgentDefault(agent);
        }) || candidates[0];
        if (!chosen)
            return;
        if (chosen.isWorkflow) {
            setSelectedWorkflowAgentId(VoiceAgentLayoutUtils_1.getAgentId(chosen.agent));
        }
        else {
            setSelectedSelection(VoiceAgentLayoutUtils_1.getAgentId(chosen.agent));
        }
        // isAgentDefault is a plain helper recreated each render.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        agents,
        workflowAgents,
        selectedSelection,
        selectedWorkflowAgentId,
        isLoading,
        isWorkflowAgentsLoading,
    ]);
    react_1["default"].useEffect(function () {
        if (selectedSelection === VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION) {
            setCurrentCommonDraft(currentCommonConfiguration);
            setIsCommonEdited(false);
            setCurrentAgentDraft(null);
            return;
        }
        if (!selectedAgent) {
            setCurrentAgentDraft(null);
            return;
        }
        var selectedAgentDraft = VoiceAgentLayoutUtils_1.toAgentDraft(selectedAgent);
        setCurrentAgentDraft(selectedAgentDraft);
        setIsLocalEdited(Boolean(selectedAgentDraft === null || selectedAgentDraft === void 0 ? void 0 : selectedAgentDraft.isNew));
        setIsCommonEdited(false);
        if (lastAccordionResetAgentIdRef.current !== selectedAgentId) {
            setDynamicSettingsAccordionActive(false);
            lastAccordionResetAgentIdRef.current = selectedAgentId;
        }
    }, [botSettings, selectedAgent, selectedAgentId, selectedSelection]);
    react_1["default"].useEffect(function () {
        if (selectedSelection !== VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION) {
            setCurrentCommonDraft(currentCommonConfiguration);
            return;
        }
        if (!isCommonEdited) {
            setCurrentCommonDraft(currentCommonConfiguration);
        }
    }, [currentCommonConfiguration, isCommonEdited, selectedSelection]);
    react_1["default"].useEffect(function () {
        setCurrentCommonDraft(currentCommonConfiguration);
        setCommonTools([]);
        setAgents([]);
        setWorkflowAgents([]);
        setIsWorkflowAgentsLoading(true);
        setSelectedWorkflowAgentId(null);
        setWorkflowBuilderAgent(null);
        setAgentSettingsTemplate([]);
        setSelectedSelection(null);
        setCurrentAgentDraft(null);
        setIsLocalEdited(false);
        setIsCommonEdited(false);
        setIsLoading(true);
        setIsModelsLoading(true);
        setIsAddAgentModalActive(false);
        setNewAgentName('');
        setNewAgentNameError('');
    }, [activeDomainId]);
    react_1["default"].useEffect(function () {
        if (!Number.isFinite(pipecatVoiceId)) {
            setAgents([]);
            setAgentSettingsTemplate([]);
            setSelectedSelection(null);
            setCurrentAgentDraft(null);
            setIsLocalEdited(false);
            setIsCommonEdited(false);
            setIsLoading(false);
            setIsModelsLoading(false);
            return;
        }
        fetchMultiAgents();
        fetchVoiceModels();
    }, [pipecatVoiceId, fetchMultiAgents, fetchVoiceModels]);
    react_1["default"].useEffect(function () {
        fetchWorkflowAgents();
    }, [fetchWorkflowAgents]);
    react_1["default"].useEffect(function () {
        var prev = lastSelectedSelectionRef.current;
        lastSelectedSelectionRef.current = selectedSelection;
        if (prev &&
            selectedSelection &&
            String(prev).startsWith('new-') &&
            !String(selectedSelection).startsWith('new-')) {
            // Transitioning from temp agent ID to real agent ID: do not reset!
            return;
        }
        if (prev !== selectedSelection) {
            setActiveCodeEditor(null);
        }
    }, [selectedSelection]);
    react_1["default"].useEffect(function () {
        var _a, _b;
        if (!languagesList.length) {
            initializedLanguageKeyRef.current = '';
            setSelectedLanguage(null);
            return;
        }
        var draftKey = String((_b = (_a = currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id) !== null && _a !== void 0 ? _a : selectedAgentId) !== null && _b !== void 0 ? _b : 'none');
        var selectedLanguageCode = (selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.code) || (selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.id);
        var selectedExists = selectedLanguageCode
            ? languagesList.some(function (lang) {
                return lang.code === selectedLanguageCode ||
                    lang.id === selectedLanguageCode;
            })
            : false;
        var shouldInitialize = initializedLanguageKeyRef.current !== draftKey || !selectedExists;
        if (shouldInitialize) {
            setSelectedLanguage(getDefaultLanguage());
            initializedLanguageKeyRef.current = draftKey;
        }
    }, [
        currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id,
        currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.languageSpecificInstructions,
        languagesList,
        selectedAgentId,
        selectedLanguage,
    ]);
    react_1["default"].useEffect(function () {
        if (onDirtyStateChange) {
            onDirtyStateChange(Boolean(isLocalEdited || isCommonEdited || isEdited));
        }
        return function () {
            if (onDirtyStateChange)
                onDirtyStateChange(false);
        };
    }, [isCommonEdited, isLocalEdited, isEdited, onDirtyStateChange]);
    var updateAgentDraft = function (field, value) {
        setCurrentAgentDraft(function (prev) {
            var _a;
            var updatedDraft = __assign(__assign({}, (prev || {})), (_a = {}, _a[field] = value, _a));
            if (field === 'role' && value === 'faq') {
                var removedToolIds = (updatedDraft.tools || [])
                    .map(function (tool) { return tool === null || tool === void 0 ? void 0 : tool.id; })
                    .filter(function (toolId) { return toolId !== null && toolId !== undefined; });
                updatedDraft.deletedToolIds = Array.from(new Set(__spreadArrays((updatedDraft.deletedToolIds || []), removedToolIds)));
                updatedDraft.isDefault = false;
                updatedDraft.tools = [];
                updatedDraft.commonToolIds = [];
            }
            return updatedDraft;
        });
        setIsLocalEdited(true);
    };
    var isCommonToolEnabled = function (toolId) {
        if (toolId === null || toolId === undefined)
            return false;
        return ((currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.commonToolIds) || []).some(function (commonToolId) { return String(commonToolId) === String(toolId); });
    };
    var updateCommonToolAccess = function (toolId, enabled) {
        var _a;
        if (toolId === null || toolId === undefined)
            return;
        if (!enabled && (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.role) === 'tool_caller') {
            var existingIds = VoiceAgentLayoutUtils_1.normalizeCommonToolIds(currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.commonToolIds);
            var isToolCurrentlyEnabled = existingIds.some(function (id) { return String(id) === String(toolId); });
            if (isToolCurrentlyEnabled) {
                var agentToolsCount = ((_a = currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.tools) !== null && _a !== void 0 ? _a : []).length;
                if (existingIds.length + agentToolsCount <= 1) {
                    BotActions_1.createAlert("Cannot disable this tool. The agent \"" + ((currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.name) || 'current agent') + "\" has 'tool_caller' role and requires at least one tool.", null, MogamboConstants_1.AlertTypes.NEGATIVE);
                    return;
                }
            }
        }
        setCurrentAgentDraft(function (prev) {
            var existingIds = VoiceAgentLayoutUtils_1.normalizeCommonToolIds(prev === null || prev === void 0 ? void 0 : prev.commonToolIds);
            var nextIds = enabled
                ? VoiceAgentLayoutUtils_1.normalizeCommonToolIds(__spreadArrays(existingIds, [toolId]))
                : existingIds.filter(function (commonToolId) { return String(commonToolId) !== String(toolId); });
            return __assign(__assign({}, (prev || {})), { commonToolIds: nextIds });
        });
        setIsLocalEdited(true);
    };
    var updateAgentSettingsDraft = function (key, value) {
        setCurrentAgentDraft(function (prev) {
            var _a;
            return (__assign(__assign({}, (prev || {})), { agentSettings: __assign(__assign({}, ((prev === null || prev === void 0 ? void 0 : prev.agentSettings) || {})), (_a = {}, _a[key] = value, _a)) }));
        });
        setIsLocalEdited(true);
    };
    var updateCommonDraft = function (field, value) {
        setCurrentCommonDraft(function (prev) {
            var _a;
            return (__assign(__assign({}, (prev || currentCommonConfiguration)), (_a = {}, _a[field] = value, _a)));
        });
        setIsCommonEdited(true);
    };
    var updateToolDraft = function (index, field, value) {
        if (selectedSelection === VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION) {
            setCurrentCommonDraft(function (prev) {
                var _a;
                var _b;
                var updatedTools = __spreadArrays(((_b = prev === null || prev === void 0 ? void 0 : prev.tools) !== null && _b !== void 0 ? _b : []));
                updatedTools[index] = __assign(__assign({}, (updatedTools[index] || VoiceAgentLayoutUtils_1.normalizeTool({}))), (_a = {}, _a[field] = value, _a));
                return __assign(__assign({}, (prev || currentCommonConfiguration)), { tools: updatedTools });
            });
            setIsCommonEdited(true);
            return;
        }
        setCurrentAgentDraft(function (prev) {
            var _a;
            var _b;
            var updatedTools = __spreadArrays(((_b = prev === null || prev === void 0 ? void 0 : prev.tools) !== null && _b !== void 0 ? _b : []));
            updatedTools[index] = __assign(__assign({}, (updatedTools[index] || VoiceAgentLayoutUtils_1.normalizeTool({}))), (_a = {}, _a[field] = value, _a));
            return __assign(__assign({}, (prev || {})), { tools: updatedTools });
        });
        setIsLocalEdited(true);
    };
    var validateToolDelete = function (index) {
        var _a, _b, _c, _d, _e;
        if (selectedSelection === VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION) {
            var toolBeingDeleted = (_a = currentCommonDraft === null || currentCommonDraft === void 0 ? void 0 : currentCommonDraft.tools) === null || _a === void 0 ? void 0 : _a[index];
            if (!(toolBeingDeleted === null || toolBeingDeleted === void 0 ? void 0 : toolBeingDeleted.id)) {
                return null;
            }
            var mappedAgents = agents.map(VoiceAgentLayoutUtils_1.toAgentDraft);
            var toolOnlyAgents = mappedAgents.filter(function (a) { return a.role === 'tool_caller'; });
            var _loop_1 = function (agent) {
                var agentCommonToolIds = Array.isArray(agent.commonToolIds)
                    ? agent.commonToolIds.map(String)
                    : [];
                var isCommonToolPresentInAgent = agentCommonToolIds.includes(String(toolBeingDeleted.id));
                if (isCommonToolPresentInAgent) {
                    var agentToolsCount = ((_b = agent.tools) !== null && _b !== void 0 ? _b : []).length;
                    var remainingCommonToolsCount = ((_c = currentCommonDraft === null || currentCommonDraft === void 0 ? void 0 : currentCommonDraft.tools) !== null && _c !== void 0 ? _c : []).filter(function (t, i) {
                        if (i === index)
                            return false;
                        return (t === null || t === void 0 ? void 0 : t.id) && agentCommonToolIds.includes(String(t.id));
                    }).length;
                    var totalToolsCount = agentToolsCount + remainingCommonToolsCount;
                    if (totalToolsCount === 0) {
                        return { value: "Cannot delete this tool. The agent \"" + agent.name + "\" has 'tool_caller' role and requires at least one tool." };
                    }
                }
            };
            for (var _i = 0, toolOnlyAgents_1 = toolOnlyAgents; _i < toolOnlyAgents_1.length; _i++) {
                var agent = toolOnlyAgents_1[_i];
                var state_1 = _loop_1(agent);
                if (typeof state_1 === "object")
                    return state_1.value;
            }
        }
        else {
            if ((currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.role) === 'tool_caller') {
                var agentCommonToolsCount = ((_d = currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.commonToolIds) !== null && _d !== void 0 ? _d : [])
                    .length;
                var agentToolsCount = ((_e = currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.tools) !== null && _e !== void 0 ? _e : []).length;
                if (agentCommonToolsCount + agentToolsCount <= 1) {
                    return "Cannot delete this tool. The agent \"" + ((currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.name) || 'current agent') + "\" has 'tool_caller' role and requires at least one tool.";
                }
            }
        }
        return null;
    };
    var onDeleteTool = function (index) {
        if (selectedSelection === VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION) {
            setCurrentCommonDraft(function (prev) {
                var _a;
                var updatedTools = __spreadArrays(((_a = prev === null || prev === void 0 ? void 0 : prev.tools) !== null && _a !== void 0 ? _a : []));
                updatedTools.splice(index, 1);
                return __assign(__assign({}, (prev || currentCommonConfiguration)), { tools: updatedTools });
            });
            setIsCommonEdited(true);
            return;
        }
        setCurrentAgentDraft(function (prev) {
            var _a;
            var updatedTools = __spreadArrays(((_a = prev === null || prev === void 0 ? void 0 : prev.tools) !== null && _a !== void 0 ? _a : []));
            var removedTool = updatedTools[index];
            var removedToolId = removedTool === null || removedTool === void 0 ? void 0 : removedTool.id;
            updatedTools.splice(index, 1);
            return __assign(__assign({}, (prev || {})), { tools: updatedTools, deletedToolIds: removedToolId === null || removedToolId === undefined
                    ? (prev === null || prev === void 0 ? void 0 : prev.deletedToolIds) || []
                    : Array.from(new Set(__spreadArrays(((prev === null || prev === void 0 ? void 0 : prev.deletedToolIds) || []), [removedToolId]))) });
        });
        setIsLocalEdited(true);
    };
    var getAffectedRoutingAgents = function (targetAgentName, deletingAgentId) {
        return agents
            .filter(function (agent) { return VoiceAgentLayoutUtils_1.getAgentId(agent) !== deletingAgentId; })
            .map(function (agent) {
            var draft = VoiceAgentLayoutUtils_1.toAgentDraft(agent);
            var removedTools = ((draft === null || draft === void 0 ? void 0 : draft.tools) || []).filter(function (tool) {
                return (tool === null || tool === void 0 ? void 0 : tool.mode) === 'handoff' && (tool === null || tool === void 0 ? void 0 : tool.nextAgent) === targetAgentName;
            });
            if (!removedTools.length)
                return null;
            return {
                id: draft === null || draft === void 0 ? void 0 : draft.id,
                isNew: Boolean(draft === null || draft === void 0 ? void 0 : draft.isNew),
                name: VoiceAgentLayoutUtils_1.getAgentName(agent, 0),
                removedTools: removedTools,
                updatedDraft: __assign(__assign({}, draft), { tools: ((draft === null || draft === void 0 ? void 0 : draft.tools) || []).filter(function (tool) {
                        return !((tool === null || tool === void 0 ? void 0 : tool.mode) === 'handoff' &&
                            (tool === null || tool === void 0 ? void 0 : tool.nextAgent) === targetAgentName);
                    }), deletedToolIds: Array.from(new Set(__spreadArrays(((draft === null || draft === void 0 ? void 0 : draft.deletedToolIds) || []), removedTools
                        .map(function (tool) { return tool === null || tool === void 0 ? void 0 : tool.id; })
                        .filter(function (toolId) { return toolId !== null && toolId !== undefined; })))) }),
            };
        })
            .filter(Boolean);
    };
    var onAddTool = function () {
        if (selectedSelection === VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION) {
            setCurrentCommonDraft(function (prev) {
                var _a;
                return (__assign(__assign({}, (prev || currentCommonConfiguration)), { tools: __spreadArrays(((_a = prev === null || prev === void 0 ? void 0 : prev.tools) !== null && _a !== void 0 ? _a : []), [
                        VoiceAgentLayoutUtils_1.normalizeTool({ id: null, isNew: true }),
                    ]) }));
            });
            setIsCommonEdited(true);
            return;
        }
        setCurrentAgentDraft(function (prev) {
            var _a;
            return (__assign(__assign({}, (prev || {})), { tools: __spreadArrays(((_a = prev === null || prev === void 0 ? void 0 : prev.tools) !== null && _a !== void 0 ? _a : []), [VoiceAgentLayoutUtils_1.normalizeTool({ id: null, isNew: true })]) }));
        });
        setIsLocalEdited(true);
    };
    var showToolValidationError = function (validationError) {
        if (!validationError)
            return false;
        if ((validationError === null || validationError === void 0 ? void 0 : validationError.toolIndex) === undefined) {
            BotActions_1.createAlert(validationError.message, null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return true;
        }
        if ((validationError === null || validationError === void 0 ? void 0 : validationError.parameterIndex) !== undefined) {
            var parameterFieldLabel = validationError.field === 'name_format'
                ? 'name can only contain letters, numbers and underscore'
                : validationError.field + " is required";
            BotActions_1.createAlert("Tool " + (validationError.toolIndex + 1) + ", Parameter " + (validationError.parameterIndex + 1) + ": " + parameterFieldLabel + ".", null, MogamboConstants_1.AlertTypes.NEGATIVE);
            return true;
        }
        BotActions_1.createAlert("Tool " + (validationError.toolIndex + 1) + ": " + validationError.message, null, MogamboConstants_1.AlertTypes.NEGATIVE);
        return true;
    };
    var onAddAgent = function () {
        if (isLocalEdited || isCommonEdited || isEdited) {
            BotActions_1.showConfirmationDialog({
                okTitle: 'Continue',
                cancelTitle: 'Keep Editing',
                title: 'Create a new agent?',
                message: 'Your unsaved changes in the current agent will be lost if you continue.',
                okActionType: 'danger',
                onCancel: function () { },
                onOk: function () {
                    setIsAddAgentModalActive(true);
                    setNewAgentName('');
                    setNewAgentNameError('');
                },
            });
            return;
        }
        setIsAddAgentModalActive(true);
        setNewAgentName('');
        setNewAgentNameError('');
    };
    var onConfirmAddAgent = function () { return __awaiter(void 0, void 0, void 0, function () {
        var trimmedAgentName, isDuplicateAgentName, tempId, localNewAgent;
        return __generator(this, function (_a) {
            trimmedAgentName = (newAgentName || '').trim();
            if (!trimmedAgentName) {
                setNewAgentNameError('Agent name is required.');
                BotActions_1.createAlert('Please enter an agent name.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                return [2 /*return*/];
            }
            if (trimmedAgentName.length < 5 || trimmedAgentName.length > 50) {
                setNewAgentNameError('Agent name must be between 5 and 50 characters.');
                BotActions_1.createAlert('Agent name must be between 5 and 50 characters.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                return [2 /*return*/];
            }
            if (!VoiceAgentLayoutUtils_1.AGENT_NAME_REGEX.test(trimmedAgentName)) {
                setNewAgentNameError('Agent name can only contain letters, numbers, spaces and underscore.');
                BotActions_1.createAlert('Agent name can only contain letters, numbers, spaces and underscore.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                return [2 /*return*/];
            }
            isDuplicateAgentName = __spreadArrays(agents, workflowAgents).some(function (agent) {
                return (VoiceAgentLayoutUtils_1.getAgentName(agent, 0) || '').trim().toLowerCase() ===
                    trimmedAgentName.toLowerCase();
            });
            if (isDuplicateAgentName) {
                setNewAgentNameError('An agent with this name already exists.');
                BotActions_1.createAlert('Agent name already exists. Please choose a different name.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                return [2 /*return*/];
            }
            setNewAgentNameError('');
            if (!Number.isFinite(pipecatVoiceId) && onAddAgentClick) {
                onAddAgentClick();
            }
            tempId = "new-" + Date.now();
            localNewAgent = {
                id: tempId,
                name: trimmedAgentName,
                title: trimmedAgentName,
                llm_provider: '',
                llm_model: '',
                instructions: '',
                language_specific_instructions: {},
                role: 'specialist',
                // Workflow agents are held separately from `agents`, so counting only
                // the latter would mark this agent default on a bot whose workflow
                // agent already is one.
                is_default: !agents.length && !workflowAgents.length,
                date_time_context_enabled: false,
                deleted_tool_ids: [],
                common_tool_ids: [],
                agentSettings: {},
                tools: [],
                isNew: true,
            };
            setAgents(function (prev) { return __spreadArrays(prev, [localNewAgent]); });
            // The workflow agent pane replaces the standard one whenever a workflow
            // agent stays selected, which would leave the new agent unreachable.
            setSelectedWorkflowAgentId(null);
            setSelectedSelection(tempId);
            setCurrentAgentDraft(VoiceAgentLayoutUtils_1.toAgentDraft(localNewAgent));
            setIsLocalEdited(true);
            setIsAddAgentModalActive(false);
            setNewAgentName('');
            setNewAgentNameError('');
            return [2 /*return*/];
        });
    }); };
    var onSave = function (overrideDraft, launchWorkflowBuilder) {
        if (launchWorkflowBuilder === void 0) { launchWorkflowBuilder = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var draftToSave_1, trimmedCommonDraft, toolValidationError_1, uniqueToolNameError_1, commonDraftWithLambdaNames, payload, saveResponse, refreshedDomainData, error_1, draftToSave, trimmedDraft, payload, request, _a, success, response, body, savedAgent, savedAgentId, error_2, toolValidationError, uniqueToolNameError, draftWithComputedLambdaNames, agentDraftWithLambdaNames, requestPromise, _b, success, response, createdAgentId, error_3;
            var _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        if (!(selectedSelection === VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION)) return [3 /*break*/, 9];
                        draftToSave_1 = overrideDraft || currentCommonDraft;
                        trimmedCommonDraft = VoiceAgentLayoutUtils_1.trimCommonConfigurationDraft(draftToSave_1);
                        setCurrentCommonDraft(trimmedCommonDraft);
                        toolValidationError_1 = VoiceAgentLayoutUtils_1.validateVoiceAgentTools(trimmedCommonDraft === null || trimmedCommonDraft === void 0 ? void 0 : trimmedCommonDraft.tools);
                        if (showToolValidationError(toolValidationError_1)) {
                            return [2 /*return*/];
                        }
                        uniqueToolNameError_1 = VoiceAgentLayoutUtils_1.validateUniqueVoiceAgentToolNames(trimmedCommonDraft === null || trimmedCommonDraft === void 0 ? void 0 : trimmedCommonDraft.tools, allAgentTools, {
                            currentScopeLabel: 'common tools',
                            referenceScopeLabel: 'agent tools',
                        });
                        if (showToolValidationError(uniqueToolNameError_1)) {
                            return [2 /*return*/];
                        }
                        if (!Number.isFinite(pipecatVoiceId)) {
                            if (onParentSave)
                                onParentSave();
                            return [2 /*return*/];
                        }
                        setIsSaving(true);
                        _h.label = 1;
                    case 1:
                        _h.trys.push([1, 6, 7, 8]);
                        return [4 /*yield*/, ensureToolCallLambdaNames(stripQuickToolLambdaNames(trimmedCommonDraft))];
                    case 2:
                        commonDraftWithLambdaNames = _h.sent();
                        setCurrentCommonDraft(commonDraftWithLambdaNames);
                        payload = VoiceAgentLayoutUtils_1.buildCommonConfigurationPayload(botSettings, commonDraftWithLambdaNames);
                        return [4 /*yield*/, api_1.createBot(payload)];
                    case 3:
                        saveResponse = _h.sent();
                        if (!(saveResponse === null || saveResponse === void 0 ? void 0 : saveResponse.success)) {
                            BotActions_1.createAlert((saveResponse === null || saveResponse === void 0 ? void 0 : saveResponse.error) || 'Error occurred while saving common data.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, DomainActions_1.getDomainData(activeDomainId)];
                    case 4:
                        refreshedDomainData = _h.sent();
                        if (refreshedDomainData) {
                            dispatcher_1.dispatch(MogamboConstants_1.ActionTypes.SET_CURRENT_BOT_SETTINGS, {
                                settings: refreshedDomainData,
                            });
                            reduxDispatch(actions_1.setDomainData(refreshedDomainData));
                        }
                        return [4 /*yield*/, fetchMultiAgents(VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION, false)];
                    case 5:
                        _h.sent();
                        setIsCommonEdited(false);
                        BotActions_1.createAlert('Successfully saved the common configuration.', null, MogamboConstants_1.AlertTypes.POSITIVE);
                        setIsCommonEdited(false);
                        return [3 /*break*/, 8];
                    case 6:
                        error_1 = _h.sent();
                        BotActions_1.createAlert((error_1 === null || error_1 === void 0 ? void 0 : error_1.message) || 'Error occurred while saving common configuration.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                        api_1.captureException(error_1);
                        return [3 /*break*/, 8];
                    case 7:
                        setIsSaving(false);
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                    case 9:
                        draftToSave = overrideDraft || currentAgentDraft;
                        trimmedDraft = VoiceAgentLayoutUtils_1.trimAgentDraft(draftToSave);
                        setCurrentAgentDraft(trimmedDraft);
                        if (!((trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.role) === 'workflow')) return [3 /*break*/, 16];
                        if (!workflowDomainId) {
                            BotActions_1.createAlert('A bot must be selected before saving a workflow agent.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                            return [2 /*return*/];
                        }
                        setIsSaving(true);
                        _h.label = 10;
                    case 10:
                        _h.trys.push([10, 13, 14, 15]);
                        payload = VoiceAgentLayoutUtils_1.buildAgentPayload(__assign(__assign({}, trimmedDraft), { tools: [], commonToolIds: [] }));
                        request = (trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.isNew) ? api_2.createWorkflowAgent(workflowDomainId, payload)
                            : api_2.updateWorkflowAgent(workflowDomainId, trimmedDraft.id, payload);
                        return [4 /*yield*/, request];
                    case 11:
                        _a = _h.sent(), success = _a.success, response = _a.response;
                        if (!success || (response === null || response === void 0 ? void 0 : response.success) === false) {
                            throw new Error(VoiceAgentLayoutUtils_1.getSaveErrorMessage(response, 'Failed to save workflow agent.'));
                        }
                        body = VoiceAgentLayoutUtils_1.getResponseBody(response);
                        savedAgent = (_c = body === null || body === void 0 ? void 0 : body.agent) !== null && _c !== void 0 ? _c : body;
                        savedAgentId = (_d = VoiceAgentLayoutUtils_1.getAgentId(savedAgent)) !== null && _d !== void 0 ? _d : trimmedDraft.id;
                        setAgents(function (currentAgents) {
                            return currentAgents.filter(function (agent) { return VoiceAgentLayoutUtils_1.getAgentId(agent) !== trimmedDraft.id; });
                        });
                        return [4 /*yield*/, fetchWorkflowAgents()];
                    case 12:
                        _h.sent();
                        setSelectedSelection(null);
                        setSelectedWorkflowAgentId(savedAgentId);
                        setIsLocalEdited(false);
                        if (launchWorkflowBuilder) {
                            setWorkflowBuilderAgent(__assign(__assign(__assign({}, trimmedDraft), (savedAgent || {})), { id: savedAgentId }));
                        }
                        BotActions_1.createAlert(launchWorkflowBuilder
                            ? 'Workflow agent saved. Opening the workflow builder.'
                            : 'Workflow agent saved.', null, MogamboConstants_1.AlertTypes.POSITIVE);
                        return [3 /*break*/, 15];
                    case 13:
                        error_2 = _h.sent();
                        BotActions_1.createAlert((error_2 === null || error_2 === void 0 ? void 0 : error_2.message) || 'Failed to save workflow agent.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                        api_1.captureException(error_2);
                        return [3 /*break*/, 15];
                    case 14:
                        setIsSaving(false);
                        return [7 /*endfinally*/];
                    case 15: return [2 /*return*/];
                    case 16:
                        if (!Number.isFinite(pipecatVoiceId)) {
                            if (onParentSave)
                                onParentSave();
                            return [2 /*return*/];
                        }
                        if (!(trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.id)) {
                            BotActions_1.createAlert('Please select an agent first.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                            return [2 /*return*/];
                        }
                        if (!(trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.modelProvider) || !(trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.model)) {
                            BotActions_1.createAlert('Please select both model provider and model before saving.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                            return [2 /*return*/];
                        }
                        toolValidationError = VoiceAgentLayoutUtils_1.validateVoiceAgentTools(trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.tools);
                        if (showToolValidationError(toolValidationError)) {
                            return [2 /*return*/];
                        }
                        uniqueToolNameError = VoiceAgentLayoutUtils_1.validateUniqueVoiceAgentToolNames(trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.tools, commonTools, {
                            currentScopeLabel: 'this agent',
                            referenceScopeLabel: 'common tools',
                        });
                        if (showToolValidationError(uniqueToolNameError)) {
                            return [2 /*return*/];
                        }
                        if ((trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.role) === 'tool_caller' &&
                            (trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.commonToolIds.length) === 0 &&
                            (trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.tools.length) === 0) {
                            BotActions_1.createAlert('Tool-only Agent must have at least one tool configured.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                            return [2 /*return*/];
                        }
                        if ((trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.role) === 'faq' && (trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.isDefault)) {
                            BotActions_1.createAlert('FAQ agent cannot be marked as Default. Please select another agent as Default.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                            return [2 /*return*/];
                        }
                        if ((trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.isDefault) && defaultAgentOtherThanCurrent) {
                            BotActions_1.createAlert(VoiceAgentLayoutUtils_1.getAgentName(defaultAgentOtherThanCurrent, 0) + " is already marked as Default. Unset it first.", null, MogamboConstants_1.AlertTypes.NEGATIVE);
                            return [2 /*return*/];
                        }
                        if ((trimmedDraft === null || trimmedDraft === void 0 ? void 0 : trimmedDraft.role) === 'orchestrator' &&
                            orchestratorAgentOtherThanCurrent) {
                            BotActions_1.createAlert(VoiceAgentLayoutUtils_1.getAgentName(orchestratorAgentOtherThanCurrent, 0) + " is already set as Orchestrator. Unset it first.", null, MogamboConstants_1.AlertTypes.NEGATIVE);
                            return [2 /*return*/];
                        }
                        setIsSaving(true);
                        _h.label = 17;
                    case 17:
                        _h.trys.push([17, 20, 21, 22]);
                        draftWithComputedLambdaNames = stripQuickToolLambdaNames(trimmedDraft);
                        return [4 /*yield*/, ensureToolCallLambdaNames(draftWithComputedLambdaNames)];
                    case 18:
                        agentDraftWithLambdaNames = _h.sent();
                        setCurrentAgentDraft(agentDraftWithLambdaNames);
                        requestPromise = (agentDraftWithLambdaNames === null || agentDraftWithLambdaNames === void 0 ? void 0 : agentDraftWithLambdaNames.isNew) ? api_2.createMultiAgentBot(pipecatVoiceId, VoiceAgentLayoutUtils_1.buildAgentPayload(__assign(__assign({}, agentDraftWithLambdaNames), { id: undefined })))
                            : api_2.updateMultiAgent(pipecatVoiceId, agentDraftWithLambdaNames.id, VoiceAgentLayoutUtils_1.buildAgentPayload(agentDraftWithLambdaNames));
                        return [4 /*yield*/, requestPromise];
                    case 19:
                        _b = _h.sent(), success = _b.success, response = _b.response;
                        if (!success || (response === null || response === void 0 ? void 0 : response.success) === false) {
                            BotActions_1.createAlert(VoiceAgentLayoutUtils_1.getSaveErrorMessage(response, 'Error occurred while saving agent.'), null, MogamboConstants_1.AlertTypes.NEGATIVE);
                            return [2 /*return*/];
                        }
                        BotActions_1.createAlert('Successfully saved the agent data.', null, MogamboConstants_1.AlertTypes.POSITIVE);
                        setIsLocalEdited(false);
                        createdAgentId = (_g = (_e = VoiceAgentLayoutUtils_1.getAgentId(VoiceAgentLayoutUtils_1.getResponseBody(response))) !== null && _e !== void 0 ? _e : VoiceAgentLayoutUtils_1.getAgentId((_f = VoiceAgentLayoutUtils_1.getResponseBody(response)) === null || _f === void 0 ? void 0 : _f.agent)) !== null && _g !== void 0 ? _g : agentDraftWithLambdaNames.id;
                        fetchMultiAgents(createdAgentId, false);
                        return [3 /*break*/, 22];
                    case 20:
                        error_3 = _h.sent();
                        BotActions_1.createAlert((error_3 === null || error_3 === void 0 ? void 0 : error_3.message) || 'Error occurred while saving agent.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                        api_1.captureException(error_3);
                        return [3 /*break*/, 22];
                    case 21:
                        setIsSaving(false);
                        return [7 /*endfinally*/];
                    case 22: return [2 /*return*/];
                }
            });
        });
    };
    var onDelete = function () {
        var deletingAgentName = (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.name) || '';
        var deletingAgentId = currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id;
        var affectedAgents = getAffectedRoutingAgents(deletingAgentName, deletingAgentId);
        var totalAffectedTools = affectedAgents.reduce(function (acc, agent) { var _a; return acc + (((_a = agent === null || agent === void 0 ? void 0 : agent.removedTools) === null || _a === void 0 ? void 0 : _a.length) || 0); }, 0);
        var affectedAgentsText = affectedAgents
            .map(function (agent) { return (agent === null || agent === void 0 ? void 0 : agent.name) + " (" + (agent === null || agent === void 0 ? void 0 : agent.removedTools.length) + ")"; })
            .join(', ');
        var deleteMessage = affectedAgents.length ? (react_1["default"].createElement(box_1["default"], null,
            react_1["default"].createElement(text_1["default"], { variant: "body.md", style: { whiteSpace: 'pre-line', fontSize: '15px' } }, "This agent is used as routing target in " + totalAffectedTools + " tool(s) in: " + affectedAgentsText + ".\nThose routing tools will also be deleted."))) : ('This action cannot be undone.');
        BotActions_1.showConfirmationDialog({
            okTitle: 'Delete',
            cancelTitle: 'Cancel',
            title: "Are you sure you want to delete '" + ((currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.name) || 'this agent') + "'?",
            message: deleteMessage,
            okActionType: 'danger',
            onCancel: function () { },
            onOk: function () {
                if (affectedAgents.length) {
                    setAgents(function (prevAgents) {
                        return prevAgents.map(function (agent) {
                            var agentId = VoiceAgentLayoutUtils_1.getAgentId(agent);
                            var affected = affectedAgents.find(function (a) { return (a === null || a === void 0 ? void 0 : a.id) === agentId; });
                            if (!affected || !affected.isNew)
                                return agent;
                            return __assign(__assign({}, agent), { tools: affected.updatedDraft.tools, deleted_tool_ids: affected.updatedDraft.deletedToolIds });
                        });
                    });
                }
                if (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.isNew) {
                    var updatedAgents = agents.filter(function (agent) { return VoiceAgentLayoutUtils_1.getAgentId(agent) !== (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id); });
                    setAgents(updatedAgents);
                    // Nothing selected: the selection effect opens the default agent.
                    setSelectedSelection(null);
                    if (!updatedAgents.length) {
                        setCurrentAgentDraft(null);
                    }
                    setIsLocalEdited(false);
                    return;
                }
                if (!Number.isFinite(pipecatVoiceId) || !(currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id)) {
                    if (onDeleteClick)
                        onDeleteClick(currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id);
                    return;
                }
                setIsDeleteLoading(true);
                var updateAffectedAgentsPromise = Promise.all(affectedAgents
                    .filter(function (agent) { return !(agent === null || agent === void 0 ? void 0 : agent.isNew) && (agent === null || agent === void 0 ? void 0 : agent.id); })
                    .map(function (agent) {
                    return api_2.updateMultiAgent(pipecatVoiceId, agent === null || agent === void 0 ? void 0 : agent.id, VoiceAgentLayoutUtils_1.buildAgentPayload(agent === null || agent === void 0 ? void 0 : agent.updatedDraft));
                }));
                updateAffectedAgentsPromise
                    .then(function (responses) {
                    var _a;
                    var failedUpdate = responses.find(function (_a) {
                        var success = _a.success, response = _a.response;
                        return !success || (response === null || response === void 0 ? void 0 : response.success) === false;
                    });
                    if (failedUpdate) {
                        throw new Error(((_a = failedUpdate === null || failedUpdate === void 0 ? void 0 : failedUpdate.response) === null || _a === void 0 ? void 0 : _a.error) ||
                            'Error occurred while updating routing tools.');
                    }
                    return api_2.deleteMultiAgent(pipecatVoiceId, currentAgentDraft.id, {});
                })
                    .then(function (_a) {
                    var success = _a.success, response = _a.response;
                    if (!success || (response === null || response === void 0 ? void 0 : response.success) === false) {
                        BotActions_1.createAlert((response === null || response === void 0 ? void 0 : response.error) || 'Error occurred while deleting agent.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                        return;
                    }
                    BotActions_1.createAlert('Agent deleted successfully.', null, MogamboConstants_1.AlertTypes.POSITIVE);
                    fetchMultiAgents();
                })["catch"](function (error) {
                    BotActions_1.createAlert((error === null || error === void 0 ? void 0 : error.message) || 'Error occurred while deleting agent.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                    api_1.captureException(error);
                })["finally"](function () {
                    setIsDeleteLoading(false);
                });
            },
        });
    };
    var onCommonSelect = function () {
        if (selectedSelection === VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION)
            return;
        if (isLocalEdited || isCommonEdited || isEdited) {
            BotActions_1.showConfirmationDialog({
                okTitle: 'Switch',
                cancelTitle: 'Keep Editing',
                title: 'Switch configuration?',
                message: 'Your unsaved changes will be lost once you switch views.',
                okActionType: 'danger',
                onCancel: function () { },
                onOk: function () {
                    var _a;
                    if (selectedSelection !== VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION && (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.isNew) && (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id)) {
                        setAgents(function (prevAgents) {
                            return prevAgents.filter(function (agent) { return VoiceAgentLayoutUtils_1.getAgentId(agent) !== (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id); });
                        });
                    }
                    setCurrentCommonDraft(currentCommonConfiguration);
                    setCommonTools((_a = currentCommonConfiguration.tools) !== null && _a !== void 0 ? _a : []);
                    setIsCommonEdited(false);
                    setIsLocalEdited(false);
                    setSelectedWorkflowAgentId(null);
                    setSelectedSelection(VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION);
                },
            });
            return;
        }
        setSelectedWorkflowAgentId(null);
        setSelectedSelection(VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION);
    };
    var onAgentSelect = function (agentId) {
        if (agentId === selectedSelection)
            return;
        if (isLocalEdited || isCommonEdited || isEdited) {
            BotActions_1.showConfirmationDialog({
                okTitle: 'Switch',
                cancelTitle: 'Keep Editing',
                title: 'Switch agent?',
                message: 'Your unsaved changes will be lost once you switch to another agent.',
                okActionType: 'danger',
                onCancel: function () { },
                onOk: function () {
                    var _a;
                    if (selectedSelection !== VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION && (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.isNew) && (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id)) {
                        setAgents(function (prevAgents) {
                            return prevAgents.filter(function (agent) { return VoiceAgentLayoutUtils_1.getAgentId(agent) !== (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id); });
                        });
                    }
                    setCurrentCommonDraft(currentCommonConfiguration);
                    setCommonTools((_a = currentCommonConfiguration.tools) !== null && _a !== void 0 ? _a : []);
                    setIsCommonEdited(false);
                    setIsLocalEdited(false);
                    setSelectedWorkflowAgentId(null);
                    setSelectedSelection(agentId);
                },
            });
            return;
        }
        setSelectedWorkflowAgentId(null);
        setSelectedSelection(agentId);
    };
    var onDiscardChanges = function () {
        var _a;
        if (selectedSelection === VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION) {
            setCurrentCommonDraft(currentCommonConfiguration);
            setCommonTools((_a = currentCommonConfiguration.tools) !== null && _a !== void 0 ? _a : []);
            setIsCommonEdited(false);
            setIsLocalEdited(false);
        }
        else {
            var activeAgent = agents.find(function (a) { return VoiceAgentLayoutUtils_1.getAgentId(a) === selectedSelection; }) || {};
            setCurrentAgentDraft(VoiceAgentLayoutUtils_1.toAgentDraft(activeAgent));
            setIsCommonEdited(false);
            setIsLocalEdited(false);
        }
    };
    // The workflow agent pane edits a draft and commits it on Save, like every
    // other agent pane. Toggling a control must not write to the server on its
    // own; null means "nothing edited yet".
    var _20 = react_1["default"].useState(null), workflowDefaultDraft = _20[0], setWorkflowDefaultDraft = _20[1];
    var selectedWorkflowAgent = react_1["default"].useMemo(function () {
        return workflowAgents.find(function (agent) { return VoiceAgentLayoutUtils_1.getAgentId(agent) === selectedWorkflowAgentId; }) || null;
    }, [workflowAgents, selectedWorkflowAgentId]);
    var isPersistedWorkflowDraft = Boolean((currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.role) === 'workflow' &&
        workflowAgents.some(function (agent) { return String(VoiceAgentLayoutUtils_1.getAgentId(agent)) === String(currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id); }));
    // A draft belongs to the agent it was started on; switching agents discards it.
    react_1["default"].useEffect(function () {
        setWorkflowDefaultDraft(null);
    }, [selectedWorkflowAgentId]);
    var onWorkflowAgentSelect = function (agentId) {
        if (agentId === selectedWorkflowAgentId)
            return;
        var applySelection = function () {
            setSelectedWorkflowAgentId(agentId);
            setSelectedSelection(null);
            setCurrentAgentDraft(null);
            setIsLocalEdited(false);
            setIsCommonEdited(false);
        };
        if (isLocalEdited || isCommonEdited || isEdited) {
            BotActions_1.showConfirmationDialog({
                okTitle: 'Switch',
                cancelTitle: 'Keep Editing',
                title: 'Switch agent?',
                message: 'Your unsaved changes will be lost once you switch to another agent.',
                okActionType: 'danger',
                onCancel: function () { },
                onOk: function () {
                    var _a;
                    if (selectedSelection !== VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION && (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.isNew) && (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id)) {
                        setAgents(function (prevAgents) {
                            return prevAgents.filter(function (agent) { return VoiceAgentLayoutUtils_1.getAgentId(agent) !== (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id); });
                        });
                    }
                    setCurrentCommonDraft(currentCommonConfiguration);
                    setCommonTools((_a = currentCommonConfiguration.tools) !== null && _a !== void 0 ? _a : []);
                    applySelection();
                },
            });
            return;
        }
        applySelection();
    };
    var onDeleteWorkflowAgent = function () {
        if (!workflowDomainId || !selectedWorkflowAgent)
            return;
        var agentId = VoiceAgentLayoutUtils_1.getAgentId(selectedWorkflowAgent);
        var agentName = VoiceAgentLayoutUtils_1.getAgentName(selectedWorkflowAgent, 0);
        BotActions_1.showConfirmationDialog({
            okTitle: 'Delete',
            cancelTitle: 'Cancel',
            title: 'Delete workflow agent?',
            message: agentName + " and all of its workflow steps will be deleted. This cannot be undone.",
            okActionType: 'danger',
            onCancel: function () { },
            onOk: function () { return __awaiter(void 0, void 0, void 0, function () {
                var _a, success, response, error_4;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            setIsDeleteLoading(true);
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 4, 5, 6]);
                            return [4 /*yield*/, api_2.deleteWorkflowAgent(workflowDomainId, agentId)];
                        case 2:
                            _a = _b.sent(), success = _a.success, response = _a.response;
                            if (!success || (response === null || response === void 0 ? void 0 : response.success) === false) {
                                throw new Error((response === null || response === void 0 ? void 0 : response.error) || 'Failed to delete workflow agent.');
                            }
                            setSelectedWorkflowAgentId(null);
                            setWorkflowBuilderAgent(null);
                            return [4 /*yield*/, fetchWorkflowAgents()];
                        case 3:
                            _b.sent();
                            BotActions_1.createAlert('Workflow agent deleted.', null, MogamboConstants_1.AlertTypes.POSITIVE);
                            return [3 /*break*/, 6];
                        case 4:
                            error_4 = _b.sent();
                            BotActions_1.createAlert((error_4 === null || error_4 === void 0 ? void 0 : error_4.message) || 'Failed to delete workflow agent.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                            api_1.captureException(error_4);
                            return [3 /*break*/, 6];
                        case 5:
                            setIsDeleteLoading(false);
                            return [7 /*endfinally*/];
                        case 6: return [2 /*return*/];
                    }
                });
            }); },
        });
    };
    var updateWorkflowDefault = function (value) {
        var _a;
        if (!selectedWorkflowAgent)
            return;
        var isDefault = typeof value === 'boolean' ? value : (_a = value === null || value === void 0 ? void 0 : value.target) === null || _a === void 0 ? void 0 : _a.checked;
        // Some Toggle implementations pass the DOM event rather than its checked
        // value. Do not serialize that event into the workflow PATCH payload.
        if (typeof isDefault !== 'boolean')
            return;
        setWorkflowDefaultDraft(isDefault);
    };
    var workflowAgentHasUnsavedChanges = workflowDefaultDraft !== null &&
        workflowDefaultDraft !== Boolean(selectedWorkflowAgent === null || selectedWorkflowAgent === void 0 ? void 0 : selectedWorkflowAgent.is_default);
    var saveWorkflowAgent = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isDefault, _a, success, response, error_5;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!workflowDomainId || !selectedWorkflowAgent)
                        return [2 /*return*/];
                    isDefault = workflowDefaultDraft;
                    if (typeof isDefault !== 'boolean')
                        return [2 /*return*/];
                    if (isDefault === Boolean(selectedWorkflowAgent.is_default))
                        return [2 /*return*/];
                    setIsSaving(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, api_2.updateWorkflowAgent(workflowDomainId, VoiceAgentLayoutUtils_1.getAgentId(selectedWorkflowAgent), { is_default: isDefault })];
                case 2:
                    _a = _b.sent(), success = _a.success, response = _a.response;
                    if (!success || (response === null || response === void 0 ? void 0 : response.success) === false) {
                        throw new Error((response === null || response === void 0 ? void 0 : response.error) || 'Failed to update workflow agent.');
                    }
                    return [4 /*yield*/, fetchWorkflowAgents()];
                case 3:
                    _b.sent();
                    setWorkflowDefaultDraft(null);
                    BotActions_1.createAlert('Workflow agent updated successfully.', null, MogamboConstants_1.AlertTypes.POSITIVE);
                    return [3 /*break*/, 6];
                case 4:
                    error_5 = _b.sent();
                    BotActions_1.createAlert((error_5 === null || error_5 === void 0 ? void 0 : error_5.message) || 'Failed to update workflow agent.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                    api_1.captureException(error_5);
                    return [3 /*break*/, 6];
                case 5:
                    setIsSaving(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var selectedProvider = providerOptions.find(function (provider) { return provider.id === (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.modelProvider); }) || {};
    var selectedModel = modelOptions.find(function (model) { return model.id === (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.model); }) || {};
    var selectedRole = VoiceAgentLayoutUtils_1.AGENT_ROLE_OPTIONS.find(function (role) { return role.id === (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.role); }) ||
        VoiceAgentLayoutUtils_1.AGENT_ROLE_OPTIONS[0];
    // The backend refuses to turn a saved agent into a Workflow Agent (or back),
    // since the two are stored differently. Only a new agent may pick Workflow.
    var roleOptions = (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.isNew) ? VoiceAgentLayoutUtils_1.AGENT_ROLE_OPTIONS
        : VoiceAgentLayoutUtils_1.AGENT_ROLE_OPTIONS.filter(function (role) { return role.id !== 'workflow'; });
    var currentAgentIndex = agents.findIndex(function (agent) { return VoiceAgentLayoutUtils_1.getAgentId(agent) === (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.id); });
    var isCommonConfigurationSelected = selectedSelection === VoiceAgentLayoutUtils_1.COMMON_CONFIGURATION_SELECTION;
    var hasUnsavedChanges = Boolean(isCommonEdited || isLocalEdited || isEdited);
    var isWorkflowAgentDraft = (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.role) === 'workflow';
    // The workflow agent panel replaces the standard agent detail pane.
    var showAgentDetails = !selectedWorkflowAgent &&
        (selectedSelection !== null || isLoading || isModelsLoading);
    if (workflowBuilderAgent && workflowDomainId) {
        return (react_1["default"].createElement(WorkflowAgentBuilder_1["default"], { domainId: workflowDomainId, agentId: VoiceAgentLayoutUtils_1.getAgentId(workflowBuilderAgent), agentName: VoiceAgentLayoutUtils_1.getAgentName(workflowBuilderAgent, 0), languages: languagesList, voiceModels: voiceModels, audioRegenerationInProgress: workflowAudioRegenerationInProgress, audioRegenerationFailed: workflowAudioRegenerationFailed, onClose: function () { return setWorkflowBuilderAgent(null); } }));
    }
    return (react_1["default"].createElement(react_1["default"].Fragment, null,
        react_1["default"].createElement(box_1["default"], { flexDirection: "row", padding: "0", style: { gap: '24px' } },
            react_1["default"].createElement(VoiceAgentSidebar_1["default"], { isLoading: isLoading, agentOptions: agentOptions, workflowAgentOptions: workflowAgents.map(function (agent, index) { return ({
                    id: VoiceAgentLayoutUtils_1.getAgentId(agent),
                    name: VoiceAgentLayoutUtils_1.getAgentName(agent, index),
                }); }), selectedSelection: selectedSelection, selectedWorkflowAgentId: selectedWorkflowAgentId, onCommonSelect: onCommonSelect, onAgentSelect: onAgentSelect, onWorkflowAgentSelect: onWorkflowAgentSelect, onAddAgent: onAddAgent }),
            selectedWorkflowAgent && (react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column", style: { flex: 1, minWidth: 0, maxWidth: '920px' } },
                react_1["default"].createElement(box_1["default"], { style: { alignSelf: 'flex-end', gap: '4px' } },
                    react_1["default"].createElement(StyledComponets_1.StyledButton, { themed: true, variant: isSaving || isDeleteLoading || store_1["default"].isProductionEnv()
                            ? 'disabled'
                            : 'warning', onClick: onDeleteWorkflowAgent, disabled: isSaving || isDeleteLoading || store_1["default"].isProductionEnv() }, isDeleteLoading ? 'Deleting...' : 'Delete'),
                    react_1["default"].createElement(StyledComponets_1.StyledButton, { themed: true, type: "primary", onClick: saveWorkflowAgent, disabled: isSaving ||
                            isDeleteLoading ||
                            store_1["default"].isProductionEnv() ||
                            !workflowAgentHasUnsavedChanges }, isSaving ? 'Saving...' : 'Save')),
                react_1["default"].createElement(box_1["default"], { flexDirection: "column", style: { gap: '24px', paddingTop: '20px' } },
                    react_1["default"].createElement(text_1["default"], { variant: "h1.semi-bold", color: "black.haptik" }, VoiceAgentLayoutUtils_1.getAgentName(selectedWorkflowAgent, 0)),
                    react_1["default"].createElement(box_1["default"], { flexDirection: "column", style: { gap: '8px' } },
                        react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Agent Role"),
                        react_1["default"].createElement(StyledComponets_1.StyledTextInputDisabled, { themed: true, value: "Workflow Agent", style: { width: '320px' } })),
                    react_1["default"].createElement(box_1["default"], { alignItems: "center", style: { gap: '8px' } },
                        react_1["default"].createElement(toggle_1["default"], { themed: true, value: workflowDefaultDraft !== null
                                ? workflowDefaultDraft
                                : Boolean(selectedWorkflowAgent === null || selectedWorkflowAgent === void 0 ? void 0 : selectedWorkflowAgent.is_default), onChange: updateWorkflowDefault, disabled: isSaving || store_1["default"].isProductionEnv(), style: { width: 'max-content' } }),
                        react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Is this Agent the \"Default\" Agent?")),
                    react_1["default"].createElement(box_1["default"], { flexDirection: "column", style: { gap: '10px', marginTop: '12px' } },
                        react_1["default"].createElement(StyledComponets_1.StyledButton, { themed: true, variant: "primary", onClick: function () { return setWorkflowBuilderAgent(selectedWorkflowAgent); }, style: { width: '260px', height: '48px' } }, "Launch Workflow Builder"),
                        react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.dark", style: { maxWidth: '440px' } }, "Design and configure this agent's workflow nodes in the visual builder."))))),
            showAgentDetails ? (react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column", style: { flex: 1, minWidth: 0 } },
                react_1["default"].createElement(box_1["default"], { style: { alignSelf: 'flex-end', gap: '4px' } },
                    !isCommonConfigurationSelected && (react_1["default"].createElement(StyledComponets_1.StyledButton, { themed: true, variant: isSaving || isDeleteLoading || !currentAgentDraft
                            ? 'disabled'
                            : 'warning', onClick: onDelete, disabled: isSaving || isDeleteLoading || !currentAgentDraft }, "Delete")),
                    react_1["default"].createElement(StyledComponets_1.StyledButton, { themed: true, type: "primary", onClick: function () { return onSave(); }, disabled: (isCommonConfigurationSelected
                            ? !currentCommonDraft
                            : !currentAgentDraft) ||
                            isSaving ||
                            isDeleteLoading ||
                            store_1["default"].isProductionEnv() ||
                            !hasUnsavedChanges }, isSaving ? 'Saving...' : 'Save')),
                react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column", style: { gap: '8px', marginTop: '8px' } },
                    (isLoading || isModelsLoading) && (react_1["default"].createElement(box_1["default"], { height: "100%", alignItems: "center", justifyContent: "center" },
                        react_1["default"].createElement(loader_1["default"], { themed: true }))),
                    isDeleteLoading && (react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.dark" }, "Deleting agent...")),
                    !isLoading && !isModelsLoading && (react_1["default"].createElement(react_1["default"].Fragment, null,
                        react_1["default"].createElement(box_1["default"], { flexDirection: "column", style: { gap: '6px' } },
                            react_1["default"].createElement(text_1["default"], { variant: "h1.semi-bold", color: "black.haptik" }, isCommonConfigurationSelected
                                ? 'Common Configuration'
                                : currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.name)),
                        isCommonConfigurationSelected ? (react_1["default"].createElement(react_1["default"].Fragment, null,
                            react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Common Prompt"),
                                react_1["default"].createElement(StyledComponets_1.StyledTextInput, { themed: true, multiline: true, autoExpand: true, maxHeight: 400, placeholder: "Enter common prompt", value: (_j = currentCommonDraft === null || currentCommonDraft === void 0 ? void 0 : currentCommonDraft.systemPrompt) !== null && _j !== void 0 ? _j : '', onChange: function (value) {
                                        return updateCommonDraft('systemPrompt', value);
                                    } })),
                            react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Common Guardrails"),
                                react_1["default"].createElement(StyledComponets_1.StyledTextInput, { themed: true, multiline: true, autoExpand: true, maxHeight: 400, placeholder: "Enter common guardrails", value: (_k = currentCommonDraft === null || currentCommonDraft === void 0 ? void 0 : currentCommonDraft.guardrails) !== null && _k !== void 0 ? _k : '', onChange: function (value) {
                                        return updateCommonDraft('guardrails', value);
                                    } })),
                            react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                                react_1["default"].createElement(text_1["default"], { variant: "h2.semi-bold", color: "black.haptik" }, "Common Tools"),
                                ((_l = currentCommonDraft === null || currentCommonDraft === void 0 ? void 0 : currentCommonDraft.tools) !== null && _l !== void 0 ? _l : []).map(function (tool, index) {
                                    return (react_1["default"].createElement(VoiceAgentToolItem_1["default"], { key: (tool === null || tool === void 0 ? void 0 : tool.id) || "common-tool-" + index, toolData: tool, number: index + 1, nextAgentOptions: handoffAgentOptions, onToolChange: function (field, value) {
                                            return updateToolDraft(index, field, value);
                                        }, onDeleteTool: function () { return onDeleteTool(index); }, hasUnsavedChanges: isLocalEdited || isCommonEdited || isEdited, onDiscardChanges: onDiscardChanges, openCodeEditor: (activeCodeEditor === null || activeCodeEditor === void 0 ? void 0 : activeCodeEditor.type) === 'common' &&
                                            (activeCodeEditor === null || activeCodeEditor === void 0 ? void 0 : activeCodeEditor.index) === index, onOpenCodeEditorChange: function (open) {
                                            return setActiveCodeEditor(open ? { type: 'common', index: index } : null);
                                        }, validateDelete: function () { return validateToolDelete(index); }, onOuterSave: function (code, lambdaFunctionName) { return __awaiter(void 0, void 0, void 0, function () {
                                            var updatedDraft;
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0:
                                                        updatedDraft = __assign({}, currentCommonDraft);
                                                        updatedDraft.tools = __spreadArrays((updatedDraft.tools || []));
                                                        updatedDraft.tools[index] = __assign(__assign({}, updatedDraft.tools[index]), { code: code });
                                                        if (lambdaFunctionName !== undefined) {
                                                            updatedDraft.tools[index].lambdaFunctionName = lambdaFunctionName;
                                                        }
                                                        return [4 /*yield*/, onSave(updatedDraft)];
                                                    case 1:
                                                        _a.sent();
                                                        return [2 /*return*/];
                                                }
                                            });
                                        }); } }));
                                }),
                                !((_m = currentCommonDraft === null || currentCommonDraft === void 0 ? void 0 : currentCommonDraft.tools) === null || _m === void 0 ? void 0 : _m.length) && (react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.dark" }, "No common tools added yet.")),
                                react_1["default"].createElement(box_1["default"], { padding: "0", justifyContent: "flex-end" },
                                    react_1["default"].createElement(StyledComponets_1.StyledButton, { themed: true, variant: "secondary", onClick: function () { return onAddTool(); } }, "Add tool"))))) : (react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                            !isWorkflowAgentDraft && (react_1["default"].createElement(box_1["default"], { style: { gap: '16px' } },
                                react_1["default"].createElement(dropdown_1["default"], { placeholder: "Select a model provider", themed: true, options: providerOptions, value: selectedProvider, optionKey: "name", onChange: function (val) {
                                        var _a;
                                        updateAgentDraft('modelProvider', (_a = val === null || val === void 0 ? void 0 : val.id) !== null && _a !== void 0 ? _a : '');
                                        updateAgentDraft('model', '');
                                    }, label: react_1["default"].createElement(Label_1["default"], { info: "", text: "Model Provider", isBold: true }) }),
                                react_1["default"].createElement(dropdown_1["default"], { placeholder: "Select a model", themed: true, options: modelOptions, value: selectedModel, optionKey: "name", onChange: function (val) { var _a; return updateAgentDraft('model', (_a = val === null || val === void 0 ? void 0 : val.id) !== null && _a !== void 0 ? _a : ''); }, label: react_1["default"].createElement(Label_1["default"], { info: "", text: "Model", isBold: true }) }))),
                            react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Agent Role"),
                                react_1["default"].createElement(dropdown_1["default"], { placeholder: "Select agent role", themed: true, options: roleOptions, value: selectedRole, optionKey: "name", onChange: function (val) {
                                        if ((val === null || val === void 0 ? void 0 : val.id) === 'orchestrator' &&
                                            orchestratorAgentOtherThanCurrent) {
                                            BotActions_1.createAlert(VoiceAgentLayoutUtils_1.getAgentName(orchestratorAgentOtherThanCurrent, 0) + " is already set as Orchestrator. Unset it first.", null, MogamboConstants_1.AlertTypes.NEGATIVE);
                                            return;
                                        }
                                        if ((val === null || val === void 0 ? void 0 : val.id) === 'faq' &&
                                            (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.role) !== 'faq') {
                                            BotActions_1.showConfirmationDialog({
                                                okTitle: 'Switch',
                                                cancelTitle: 'Keep Editing',
                                                title: 'Switch to FAQ agent?',
                                                message: 'All tools will get removed if you switch to FAQ agent.',
                                                okActionType: 'danger',
                                                onCancel: function () { },
                                                onOk: function () {
                                                    updateAgentDraft('role', val === null || val === void 0 ? void 0 : val.id);
                                                },
                                            });
                                            return;
                                        }
                                        updateAgentDraft('role', val === null || val === void 0 ? void 0 : val.id);
                                    }, style: { width: '200px' } }),
                                (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.role) === 'tool_caller' && (react_1["default"].createElement(box_1["default"], { style: {
                                        borderRadius: '4px',
                                        backgroundColor: 'rgb(235, 249, 252)',
                                        border: '1px solid rgb(0, 211, 244)',
                                        padding: '10px',
                                        marginTop: '8px',
                                        fontSize: '0.85em',
                                    } }, "Tool-only Agent uses the tools you explicitly configure. Built-in system tools, including \"disconnect_the_call\" and \"transfer_to_human_agent\", are disabled and will not be added automatically."))),
                            react_1["default"].createElement(box_1["default"], { alignItems: "center", style: { gap: '8px' } },
                                react_1["default"].createElement(toggle_1["default"], { themed: true, value: Boolean(currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.isDefault), onChange: function (checked) {
                                        if (checked && (currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.role) === 'faq') {
                                            BotActions_1.createAlert('FAQ agent cannot be marked as Default. Please select another agent as Default.', null, MogamboConstants_1.AlertTypes.NEGATIVE);
                                            return;
                                        }
                                        if (checked && defaultAgentOtherThanCurrent) {
                                            BotActions_1.createAlert(VoiceAgentLayoutUtils_1.getAgentName(defaultAgentOtherThanCurrent, 0) + " is already marked as Default. Unset it first.", null, MogamboConstants_1.AlertTypes.NEGATIVE);
                                            return;
                                        }
                                        updateAgentDraft('isDefault', checked);
                                    }, disabled: store_1["default"].isProductionEnv(), style: { width: 'max-content' } }),
                                noDefaultAgent &&
                                    !(currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.isDefault) &&
                                    currentAgentIndex === 0 && (react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "green.haptik" }, "(Considered Default)")),
                                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Is this Agent the \"Default\" Agent?")),
                            isWorkflowAgentDraft && (react_1["default"].createElement(StyledComponets_1.StyledButton, { themed: true, variant: "primary", onClick: function () {
                                    if (isPersistedWorkflowDraft) {
                                        setWorkflowBuilderAgent(currentAgentDraft);
                                        return;
                                    }
                                    onSave(undefined, true);
                                }, disabled: isSaving, style: {
                                    width: '260px',
                                    height: '48px',
                                    marginTop: '16px',
                                } }, "Launch Workflow Builder")),
                            !isWorkflowAgentDraft && (react_1["default"].createElement(react_1["default"].Fragment, null,
                                react_1["default"].createElement(box_1["default"], { alignItems: "center", style: { gap: '8px' } },
                                    react_1["default"].createElement(toggle_1["default"], { themed: true, value: Boolean(currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.enableDateTimeContext), onChange: function (checked) {
                                            return updateAgentDraft('enableDateTimeContext', checked);
                                        }, disabled: store_1["default"].isProductionEnv(), style: { width: 'max-content' } }),
                                    react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Enable Date/Time context for this Agent")),
                                Array.isArray(selectedAgentSettingsTemplate) &&
                                    selectedAgentSettingsTemplate.length > 0 &&
                                    !isFaq && (react_1["default"].createElement(accordion_1["default"], null,
                                    react_1["default"].createElement(StyledComponets_1.DynamicSettingsAccordionItem, { active: dynamicSettingsAccordionActive, onChange: function () {
                                            return setDynamicSettingsAccordionActive(function (active) { return !active; });
                                        }, renderHeader: function (_a) {
                                            var ExpandIcon = _a.ExpandIcon;
                                            return (react_1["default"].createElement(box_1["default"], { color: "black.haptik", padding: "8px 16px", justifyContent: "space-between", marginBottom: dynamicSettingsAccordionActive
                                                    ? '8px'
                                                    : '0', alignItems: "center" },
                                                react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold" }, "Settings"),
                                                react_1["default"].createElement(ExpandIcon, null)));
                                        } },
                                        react_1["default"].createElement(VoiceAgentDynamicSettings_1["default"], { dynamicSettings: selectedAgentSettingsTemplate, agentSettings: currentAgentDraft, onChange: updateAgentSettingsDraft })))),
                                react_1["default"].createElement(box_1["default"], { flexDirection: "column", mt: "8px" },
                                    react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Common Prompt"),
                                    react_1["default"].createElement(StyledComponets_1.StyledTextInputDisabled, { themed: true, multiline: true, autoExpand: true, maxHeight: 400, placeholder: "No common prompt added yet.", value: (_p = (_o = botSettings === null || botSettings === void 0 ? void 0 : botSettings['bot_settings']) === null || _o === void 0 ? void 0 : _o['common_system_prompt']) !== null && _p !== void 0 ? _p : '', disabled: true })),
                                react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                                    react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Agent Instructions"),
                                    react_1["default"].createElement(StyledComponets_1.StyledTextInput, { themed: true, multiline: true, autoExpand: true, maxHeight: 400, placeholder: "Enter Instructions for the agent", value: (_q = currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.instructions) !== null && _q !== void 0 ? _q : '', onChange: function (value) {
                                            return updateAgentDraft('instructions', value);
                                        } })),
                                react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                                    react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Common Guardrails"),
                                    react_1["default"].createElement(StyledComponets_1.StyledTextInputDisabled, { themed: true, multiline: true, autoExpand: true, maxHeight: 400, placeholder: "No common guardrails added yet.", value: (_s = (_r = botSettings === null || botSettings === void 0 ? void 0 : botSettings['bot_settings']) === null || _r === void 0 ? void 0 : _r['common_guardrails']) !== null && _s !== void 0 ? _s : '', disabled: true })),
                                react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                                    react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Language Specific Instructions"),
                                    react_1["default"].createElement(box_1["default"], { padding: "2px 0px 8px", style: { gap: '12px' }, alignItems: "flex-start" },
                                        react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column", style: { minWidth: '200px' } },
                                            react_1["default"].createElement(dropdown_1["default"], { themed: true, placeholder: "Select language", options: languagesList, value: selectedLanguage, optionKey: "name", onChange: function (val) { return setSelectedLanguage(val); }, style: { width: '200px' } }),
                                            react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.dark", style: { marginTop: '8px' } },
                                                configuredLanguageCount,
                                                " languages configured")),
                                        react_1["default"].createElement(StyledComponets_1.StyledTextInput, { themed: true, multiline: true, autoExpand: true, maxHeight: 400, placeholder: "Enter Instructions for the agent", value: (_u = (_t = currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.languageSpecificInstructions) === null || _t === void 0 ? void 0 : _t[selectedLanguageCode]) !== null && _u !== void 0 ? _u : '', onChange: function (value) {
                                                var _a;
                                                return updateAgentDraft('languageSpecificInstructions', __assign(__assign({}, currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.languageSpecificInstructions), (_a = {}, _a[selectedLanguageCode] = value, _a)));
                                            }, disabled: !(selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.code), style: {
                                                marginTop: '6px',
                                                minHeight: '200px',
                                            } }))),
                                !isFaq && (react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                                    react_1["default"].createElement(text_1["default"], { variant: "h3.semi-bold", color: "black.haptik" }, "Common Tools"),
                                    sharedCommonTools.length ? (react_1["default"].createElement(box_1["default"], { padding: "0", flexDirection: "column", style: { gap: '8px' } }, sharedCommonTools.map(function (tool, index) {
                                        var _a, _b;
                                        var toolId = (_b = (_a = tool === null || tool === void 0 ? void 0 : tool.id) !== null && _a !== void 0 ? _a : tool === null || tool === void 0 ? void 0 : tool['tool_id']) !== null && _b !== void 0 ? _b : tool === null || tool === void 0 ? void 0 : tool['common_tool_id'];
                                        var enabled = isCommonToolEnabled(toolId);
                                        var isSelfHandoff = isCommonToolSelfHandoff(tool);
                                        return (react_1["default"].createElement(VoiceAgentToolItem_1["default"], { key: toolId !== null && toolId !== void 0 ? toolId : "common-tool-" + index, toolData: tool, number: index + 1, nextAgentOptions: handoffAgentOptions, onToolChange: function () { }, readOnly: true, hasUnsavedChanges: isLocalEdited ||
                                                isCommonEdited ||
                                                isEdited, onDiscardChanges: onDiscardChanges, headerActions: react_1["default"].createElement(box_1["default"], { padding: "0", alignItems: "flex-end", flexDirection: "column", style: { gap: '4px' } },
                                                react_1["default"].createElement(toggle_1["default"], { themed: true, value: enabled, disabled: isSelfHandoff, onChange: function (checked) {
                                                        return updateCommonToolAccess(toolId, checked);
                                                    }, style: { width: 'max-content' } }),
                                                isSelfHandoff && (react_1["default"].createElement(text_1["default"], { variant: "body.sm", color: "red.haptik", style: { textAlign: 'right' } }, "Disabled to avoid routing back to this same agent."))) }));
                                    }))) : (react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.dark" }, "No common tools added yet.")))),
                                !isFaq && (react_1["default"].createElement(box_1["default"], { flexDirection: "column" },
                                    react_1["default"].createElement(text_1["default"], { variant: "h2.semi-bold", color: "black.haptik" }, "Tools"),
                                    ((_v = currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.tools) !== null && _v !== void 0 ? _v : []).map(function (tool, index) {
                                        return (react_1["default"].createElement(VoiceAgentToolItem_1["default"], { key: (tool === null || tool === void 0 ? void 0 : tool.id) || "tool-" + index, toolData: tool, number: index + 1, nextAgentOptions: handoffAgentOptions.filter(function (agent) { return agent.id !== selectedAgentId; }), onToolChange: function (field, value) {
                                                return updateToolDraft(index, field, value);
                                            }, onDeleteTool: function () { return onDeleteTool(index); }, hasUnsavedChanges: isLocalEdited ||
                                                isCommonEdited ||
                                                isEdited, onDiscardChanges: onDiscardChanges, openCodeEditor: (activeCodeEditor === null || activeCodeEditor === void 0 ? void 0 : activeCodeEditor.type) === 'agent' &&
                                                (activeCodeEditor === null || activeCodeEditor === void 0 ? void 0 : activeCodeEditor.index) === index, onOpenCodeEditorChange: function (open) {
                                                return setActiveCodeEditor(open ? { type: 'agent', index: index } : null);
                                            }, validateDelete: function () {
                                                return validateToolDelete(index);
                                            }, onOuterSave: function (code, lambdaFunctionName) { return __awaiter(void 0, void 0, void 0, function () {
                                                var updatedDraft;
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0:
                                                            updatedDraft = __assign({}, currentAgentDraft);
                                                            updatedDraft.tools = __spreadArrays((updatedDraft.tools || []));
                                                            updatedDraft.tools[index] = __assign(__assign({}, updatedDraft.tools[index]), { code: code });
                                                            if (lambdaFunctionName !== undefined) {
                                                                updatedDraft.tools[index].lambdaFunctionName = lambdaFunctionName;
                                                            }
                                                            return [4 /*yield*/, onSave(updatedDraft)];
                                                        case 1:
                                                            _a.sent();
                                                            return [2 /*return*/];
                                                    }
                                                });
                                            }); } }));
                                    }),
                                    !((_w = currentAgentDraft === null || currentAgentDraft === void 0 ? void 0 : currentAgentDraft.tools) === null || _w === void 0 ? void 0 : _w.length) && (react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.dark" }, "No tools added for this agent.")),
                                    react_1["default"].createElement(box_1["default"], { padding: "0", justifyContent: "flex-end" },
                                        react_1["default"].createElement(StyledComponets_1.StyledButton, { themed: true, variant: "secondary", onClick: onAddTool }, "Add tool"))))))))))))) : (!selectedWorkflowAgent &&
                !workflowAgents.length && (react_1["default"].createElement(box_1["default"], { padding: "16px", height: "calc(100vh - 140px)", alignItems: "center", justifyContent: "center", flexDirection: "column", backgroundColor: "#fff", style: { borderRadius: '8px' } },
                react_1["default"].createElement("img", { src: "https://tools-cdn.s3.ap-south-1.amazonaws.com/platform/assets/no_agents_multi_agent.png", alt: "No agents", style: { width: '40%', marginBottom: '16px' } }),
                react_1["default"].createElement(text_1["default"], { variant: "h1.semi-bold" }, "No agents in this project yet"),
                react_1["default"].createElement(text_1["default"], { variant: "body.lg", style: { marginTop: '8px', width: '50%', textAlign: 'center' } }, "Create your first AI agent using \u201CAdd Agent\u201D in the sidebar. You can add multiple agents to handle different tasks."))))),
        react_1["default"].createElement(VoiceAgentAddAgentModal_1["default"], { isActive: isAddAgentModalActive, newAgentName: newAgentName, newAgentNameError: newAgentNameError, setNewAgentName: setNewAgentName, setNewAgentNameError: setNewAgentNameError, onConfirm: onConfirmAddAgent, onClose: function () {
                setIsAddAgentModalActive(false);
                setNewAgentName('');
                setNewAgentNameError('');
            } })));
};
exports["default"] = VoiceAgentLayout;
